/**
 * Config: Canvas
 * -----------------------------------------------------------------------------
 * Custom config for Canvas, allows limited access to compiler config.
 *
 */
module.exports = {

  /**
   * Theme scripts async config.
   * - Scripts included will be loaded with `async` attribute.
   * - Other scripts default to `defer` attribute.
   */
  asyncScripts: [
    'bundle.global-components.js',
    'bundle.vendors.js',
    'layout.password.js',
    'layout.theme.js',
  ],

  /**
   * Sets branch naming convention.
   * - `camel` supports feature/CANVAS-101-branchName.
   * - `kebab` supports feature/CANVAS-101-branch-name.
   * - `both` supports both of the above.
   */
  branchNaming: 'camel',

  /**
   * CSS optimiser config.
   * - `classes` - Set classes to optimise (remove if not used).
   * - `enable` - Run CSS optimiser.
   * - `enableDevMode` - Run CSS optimiser in development mode (watch).
   * - `keep` - Do not remove these classes even if not used.
   * - `stylesheets` - Set stylesheets to optimise (remove unused classes from).
   */
  cssOptimiser: {
    classes: [
      'checkbox',
      'grid',
      'radio',
      'text-',
    ],
    enable: true,
    enableDevMode: false,
    keep: [
      'l1-9',
      'l7-12',
      'l9-12',
      'xl8-12',
      'xl10-12',
    ],
    stylesheets: ['layout.theme.css'],
  },

  /**
   * Array of custom elements not to be compiled by Vue.
   */
  customElements: ['model-viewer', 'klarna-placement'],

  /**
   * Set to true if using the custom content tool.
   */
  customContentTool: false,

  /**
   * Set breakpoints that are considered mobile.
   */
  mobileBreakpoints: ['xs', 's', 'm'],
}
